/*
 * @Author: Teemo Ding
 * @Date: 2021-08-06 14:08:18
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-10 15:43:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDatabaseSettings/FullNameAutoPopulate/index.tsx
 */

import { Radio } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const FullNameAutoPopulate = ({ disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const arrangementList = [
    {
      value: true,
      label: getI18n(
        'customerDatabaseSetting.fullNameAutoPopulate.firstnamecomesfirst',
      ),
    },
    {
      value: false,
      label: getI18n(
        'customerDatabaseSetting.fullNameAutoPopulate.lastnamecomesfirst',
      ),
    },
  ];

  const separatorList = [
    {
      value: 'Space',
      label: getI18n('customerDatabaseSetting.fullNameAutoPopulate.space'),
    },
    {
      value: 'NotUse',
      label: getI18n('customerDatabaseSetting.fullNameAutoPopulate.notUse'),
    },
    {
      value: 'Comma',
      label: getI18n('customerDatabaseSetting.fullNameAutoPopulate.comma'),
    },
  ];
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.fullNameAutoPopulate}
        title={getI18n(
          'customerDatabaseSetting.fullNameAutoPopulate.fullNameAutoPopulate',
        )}>
        <Form.Item
          className={css.fullNameAutoPopulateItem}
          label={getI18n(
            'customerDatabaseSetting.fullNameAutoPopulate.arrangement',
          )}
          name='firstNameFirst'
          labelCol={{ span: '24' }}>
          <Radio
            className={css.fullNameAutoPopulateRadioGroup}
            radioList={arrangementList}
            disabled={disabled}
          />
        </Form.Item>
        <Form.Item
          className={css.fullNameAutoPopulateItem}
          label={getI18n(
            'customerDatabaseSetting.fullNameAutoPopulate.separator',
          )}
          name='separator'
          labelCol={{ span: '24' }}>
          <Radio
            className={css.fullNameAutoPopulateRadioGroup}
            radioList={separatorList}
            disabled={disabled}
          />
        </Form.Item>
      </SectionWrapper>
    </div>
  );
};

export default FullNameAutoPopulate;
